import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/account-deletion/useAccountDeletionQueryKeys.ts
var t = e("account-deletion", { blockers: () => ["blockers"] });
//#endregion
export { t as accountDeletionQueryKeys };
